import { color, font, radius } from '../../theme/tokens.js';

/**
 * Persistent bar shown beneath the deck while a group session is running.
 *
 * Keeps the code, headcount and current front-runner visible so nobody has to
 * open the results sheet to know where things stand.
 *
 * @param {object} props
 * @param {string} props.code
 * @param {number} props.memberCount
 * @param {number} [props.submittedCount]
 * @param {{restaurant: {name: string}, votes: number} | null} props.topPick
 * @param {() => void} props.onShowResults
 * @param {(() => void) | null} props.onLeave  Null for the host, who ends the group instead.
 * @param {boolean} [props.compact]
 */
export function GroupStatusBar({
  code,
  memberCount,
  submittedCount = 0,
  topPick,
  onShowResults,
  onLeave,
  compact = false,
}) {
  return (
    <div
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        padding: compact ? '4px 10px' : '6px 14px',
        background: color.onDark,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, flex: 1, minWidth: 0 }}>
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: color.success,
            boxShadow: `0 0 0 2px ${color.success}4D`,
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontSize: compact ? 10 : 11,
            fontWeight: font.weight.bold,
            color: color.inkInverse,
            flexShrink: 0,
          }}
        >
          {code}
        </span>
        <span
          style={{ fontSize: compact ? 10 : 11, color: 'rgba(255,255,255,0.4)', flexShrink: 0 }}
        >
          · {memberCount}p · {submittedCount}/{memberCount} finished
        </span>

        {topPick && (
          <span
            style={{
              fontSize: compact ? 10 : 11,
              color: 'rgba(255,255,255,0.55)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            · Leading: <span style={{ color: color.primary }}>{topPick.restaurant.name}</span>{' '}
            {topPick.votes}/{memberCount}
          </span>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          type="button"
          onClick={onShowResults}
          style={{
            padding: compact ? '3px 7px' : '4px 9px',
            borderRadius: radius.sm,
            border: 'none',
            background: color.primary,
            color: color.inkInverse,
            fontSize: compact ? 10 : 11,
            fontWeight: font.weight.bold,
            cursor: 'pointer',
          }}
        >
          Results
        </button>
        {onLeave && (
          <button
            type="button"
            onClick={onLeave}
            style={{
              padding: '2px 0',
              background: 'none',
              border: 'none',
              color: 'rgba(255,255,255,0.4)',
              fontSize: compact ? 10 : 11,
              cursor: 'pointer',
            }}
          >
            Leave
          </button>
        )}
      </div>
    </div>
  );
}
